import { getWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
import { Product } from "./product";
import { ProductTemplateSharing } from "./product_template_sharing";
import { Project } from "./project";
import { ProjectTemplateSharing } from "./project_template_sharing";
import { Structure } from "./structure";
import { StructureTemplateSharing } from "./structure_template_sharing";
import { Supply_chain } from "./supply_chain";
import { SupplyChainTemplateSharing } from "./supply_chain_template_sharing";

const template_sharing = apiUrl + "/template_sharing";
const routes = {
  label: "Template Sharing",
  root: template_sharing,
  get_by_company_id: template_sharing + "/get_by_company_id",
  get_by_my_company: template_sharing + "/get_by_my_company",
};
export const TemplateSharing = {
  label: routes.label,
  get_by_company_id: (company_id) => getWithToken(routes.get_by_company_id, { company_id }),
  get_by_my_company: () => getWithToken(routes.get_by_my_company),
  new: (templates) => {
    const productTemplates = templates.filter((p) => p.product_id != null);
    const projectTemplates = templates.filter((p) => p.project_id != null);
    const supplyChainTemplates = templates.filter((p) => p.supply_chain_id != null);
    const structureTemplates = templates.filter((p) => p.structure_id != null);
    const jobs = [];
    if (productTemplates.length > 0) jobs.push({ key: "product", promise: ProductTemplateSharing.new(productTemplates) });
    if (projectTemplates.length > 0) jobs.push({ key: "project", promise: ProjectTemplateSharing.new(projectTemplates) });
    if (supplyChainTemplates.length > 0) jobs.push({ key: "supply_chain", promise: SupplyChainTemplateSharing.new(supplyChainTemplates) });
    if (structureTemplates.length > 0) jobs.push({ key: "structure", promise: StructureTemplateSharing.new(structureTemplates) });
    if (jobs.length === 0) return Promise.resolve([]);
    return Promise.all(jobs.map((j) => j.promise));
  },
  delete: (templates) => {
    const productTemplates = templates.filter((p) => p.product_id != null);
    const projectTemplates = templates.filter((p) => p.project_id != null);
    const supplyChainTemplates = templates.filter((p) => p.supply_chain_id != null);
    const structureTemplates = templates.filter((p) => p.structure_id != null);
    const jobs = [];
    if (productTemplates.length > 0) jobs.push({ key: "product", promise: ProductTemplateSharing.delete(productTemplates) });
    if (projectTemplates.length > 0) jobs.push({ key: "project", promise: ProjectTemplateSharing.delete(projectTemplates) });
    if (supplyChainTemplates.length > 0) jobs.push({ key: "supply_chain", promise: SupplyChainTemplateSharing.delete(supplyChainTemplates) });
    if (structureTemplates.length > 0) jobs.push({ key: "structure", promise: StructureTemplateSharing.delete(structureTemplates) });
    if (jobs.length === 0) return Promise.resolve([]);
    return Promise.all(jobs.map((j) => j.promise));
  },
  retrieve_to_workspace: (templates) => {
    const productIds = templates.filter((p) => p.product_id != null).map((p) => p.product_id);
    const projectIds = templates.filter((p) => p.project_id != null).map((p) => p.project_id);
    const supplyChainIds = templates.filter((p) => p.supply_chain_id != null).map((p) => p.supply_chain_id);
    const structureIds = templates.filter((p) => p.structure_id != null).map((p) => p.structure_id);
    const jobs = [];
    if (productIds.length > 0) jobs.push({ key: "product", promise: Product.duplicate(productIds) });
    if (projectIds.length > 0) jobs.push({ key: "project", promise: Project.duplicate(projectIds) });
    if (supplyChainIds.length > 0) jobs.push({ key: "supply_chain", promise: Supply_chain.duplicate(supplyChainIds) });
    if (structureIds.length > 0) jobs.push({ key: "structure", promise: Structure.duplicate(structureIds) });
    if (jobs.length === 0) return Promise.resolve([]);
    return Promise.all(jobs.map((j) => j.promise));
  },
};
